import React, { useState } from "react";
import { Input } from "antd";
// import EyeOpen from "../../icons/EyeOpen.svg";
// import EyeClose from "../../icons/EyeClose.svg";
import { floatInputType } from "./constants";
import { FloatInputProps } from "../../utils/types";
import { ConditionalRenderer } from "components/conditonal-renderer";
import styles from "./styles.module.scss";

export function FloatInput(props: FloatInputProps) {
  const [focus, setFocus] = useState<boolean>(false);
  const {
    compType,
    label,
    value,
    addonBeforeJsx,
    placeholder,
    type,
    required,
    iconRender,
    onChange,
    disabled,
    className,
  } = props;

  let placeholderLocal: string = placeholder || label;

  const isOccupied: boolean | string = focus || (value && value.length !== 0);

  const labelClass: string = isOccupied
    ? styles["as-label"]
    : styles["as-placeholder"];

  const requiredMark: JSX.Element | null = required ? (
    <span className="text-danger">*</span>
  ) : null;

  const conditionalAddOn = (
    compType: string | undefined,
    floatInputType: { phoneNumber: string } | undefined,
    addonBeforeJsx: JSX.Element | undefined
  ): JSX.Element | string => {
    if (floatInputType && compType === floatInputType.phoneNumber) {
      return addonBeforeJsx || "";
    } else {
      return "";
    }
  };

  return (
    <div
      className={styles["float-label"]}
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      <ConditionalRenderer condition={iconRender}>
        <Input.Password
          style={{ position: "relative" }}
          onChange={onChange}
          defaultValue=""
          autoComplete="new-password"
          className={className ? className : "myInput"}
        />
      </ConditionalRenderer>
      <ConditionalRenderer condition={!iconRender}>
        <Input
          autoComplete="off"
          onChange={onChange}
          addonBefore={conditionalAddOn(
            compType,
            floatInputType,
            addonBeforeJsx
          )}
          type={type}
          defaultValue={value}
          className={className ? className : "myInput"}
          disabled={disabled}
        />
      </ConditionalRenderer>

      <label className={labelClass}>
        {isOccupied ? label : placeholderLocal} {requiredMark}
      </label>
    </div>
  );
}
